import {isOptionalString, isOptionalStringArray, isStringArray, parseOptionalList} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {EntityCardStatus} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import {EntityCardStatusTone} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import {isOptionalMediaCount, parseOptionalEntityCardStatus} from '@Components/ai-chat-window/components/entity-card/entity-card.library';
import type {EntityDraftCardProps, EntityDraftSection} from './entity-draft-card.types';

export const parseEntityDraftCardProps = (props: Record<string, unknown>): EntityDraftCardProps | null => {
  if (!isStringArray(props.meta) || !isOptionalString(props.badge) || !isOptionalString(props.title) || !isOptionalString(props.description) || !isOptionalString(props.mediaUrl)) {
    return null;
  }

  return {
    title: props.title,
    meta: props.meta,
    status: parseOptionalEntityCardStatus(props.status) ?? undefined,
    badge: props.badge,
    description: props.description,
    mediaUrl: props.mediaUrl,
    mediaCount: isOptionalMediaCount(props.mediaCount) ? props.mediaCount : undefined,
    sections: parseOptionalList(props.sections, parseSection) ?? undefined,
    notes: isOptionalStringArray(props.notes) ? props.notes : undefined,
  };
};

export const draftStatusOf = (status: EntityCardStatus | undefined, badge: string | undefined): EntityCardStatus | undefined => {
  if (status !== undefined) {
    return status;
  }

  if (badge === undefined || badge === '') {
    return undefined;
  }

  return {label: badge, tone: EntityCardStatusTone.NEUTRAL};
};

const parseSection = (value: Record<string, unknown>): EntityDraftSection | null => {
  if (typeof value.label !== 'string' || typeof value.text !== 'string') {
    return null;
  }

  return {label: value.label, text: value.text};
};
